import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { CustomLabelInput } from "../../../../../../../components/input/CustomLabelInput";
import { Checkbox } from "@mui/material";
import { useState } from "react";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContext";
import { useSelectedReturnExchangesActionsContextHook, useSelectedReturnExchangesValueContextHook } from "../../../../contexts/SelectedReturnExchangesContext";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";
import { ReturnExchangeArchivesApi } from "../../../../../../../apis/ReturnExchangeArchivesApi";
import { useFetcher } from "../../../../fetcher/useFetcher";
import { ReturnExchangesApi } from "../../../../../../../apis/ReturnExchangesApi";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .recovery-field{
        display: flex;
        align-items: center;
        font-size: 14px;
    }

    .description{
        font-size: 14px;
    }

    input{
        border-color: #e0e0e0;
        border-radius: 3px;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        background: var(--redColor1);
        color: #fff;
        border:none;
        font-weight: 600;
        border-radius: 3px;
    }
`;

export function ModalDeleteItems({
    open,
    onClose,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();
    const selectedReturnExchangesValueContextHook = useSelectedReturnExchangesValueContextHook();
    const selectedReturnExchangesActionsContextHook = useSelectedReturnExchangesActionsContextHook();

    const [isRecoveryFlag, setIsRecoveryFlag] = useState(true);
    const [inputValue, setInputValue] = useState('');

    const handleChangeInputValue = (e) => {
        const value = e.target.value;
        setInputValue(value);
    }

    const handleSubmit = async () => {
        if (!inputValue) {
            customToast.error('입력창을 입력해 주세요.');
            return;
        }

        if (inputValue !== '영구 삭제') {
            customToast.error('입력창을 확인해 주세요.');
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formDatas: selectedReturnExchangesValueContextHook?.selectedReturnExchanges,
            recoveryFlag: isRecoveryFlag
        }

        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().deleteList({ headers: headers, body: body });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
            customToast.success('삭제되었습니다.');
            selectedReturnExchangesActionsContextHook.selectedReturnExchanges.onSet([]);
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog open={open} onClose={onClose}>
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            선택 데이터 삭제
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <div className='recovery-field'>
                        <Checkbox checked={isRecoveryFlag} onChange={(e) => { setIsRecoveryFlag(e.target.checked) }}></Checkbox>
                        <div>원본 주문데이터 복구</div>
                    </div>
                    <div className='description'>
                        <p>선택된 데이터를 삭제 하시려면 <b>"영구 삭제"</b>를 입력해 주세요.</p>
                        <p><b>복사 생성된 데이터</b>는 원본 데이터가 없으므로 복구가 되지 않습니다.</p>
                    </div>
                    <div>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={inputValue || ''}
                                onChange={handleChangeInputValue}
                            />
                            <CustomLabelInput.Label>입력</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </div>
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={handleSubmit}
                    >
                        삭제
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}